<template>
    <div class="formItem" :class="{'formError': error}">
        <h3>{{ label }}</h3>
        <span v-if="localValue.length === 0 && isDisabled === true">
            Keine Daten vorhanden
        </span>

        <!--<transition-group name="slide-fade" tag="div">-->
        <div v-for="(block, key) in localValue" :key="block.id">
            <div class="formItem">
                <ul class="entry-list" :key="block.id + '-ul'">
                    <li>
                        <a @click.prevent
                           v-if="isDisabled === false"
                           @click="removeBlock(block)"
                           href="" title="" class="icon-trash-small"></a>
                        {{ blockTypeName }} {{ key + 1 }}
                    </li>
                </ul>
            </div>
            <dynamic-layer
                    :value="block"
                    :errors="getErrorMessagesForBlock(key)"
                    :key="block.id + '-dynamic'"
                    is-matrix
                    no-class
            ></dynamic-layer>
        </div>
        <!--</transition-group>-->

        <div class="droparea" @click="addBlock" v-if="isDisabled === false">
            <i class="icon-plus"></i>
            {{ blockTypeName }} hinzufügen
        </div>
    </div>
</template>

<script>
  import DynamicLayer from '@/components/toolbox/geoobject/layers/dynamic'
  import Vue from 'vue'
  import _ from 'lodash'

  export default {
    data: () => ({
      numberOfNewBlocks: 1
    }),
    props: {
      fields: {
        required: true,
        type: [Object, Array]
      },
      blockTypeName: {
        required: true
      },
      label: {
        type: String
      },
      handle: {
        type: String
      },
      fieldLayoutId: {
        required: true,
        type: Number
      },
      value: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      error: {
        type: Boolean
      },
      errorMessages: {
        type: Object
      }
    },
    methods: {
      removeBlock (block) {
        if (this.isDisabled === true) {
          return false
        }

        const index = this.localValue.findIndex(el => el.id === block.id)
        if (index !== -1) {
          this.localValue.splice(index, 1)
          this.localValue = this.localValue.slice()
        }
      },
      addBlock () {
        if (this.isDisabled === true) {
          return false
        }

        const essentials = {
          typeId: this.fieldLayoutId,
          fieldLayoutId: this.fieldLayoutId,
          id: 'new' + this.numberOfNewBlocks,
          readonly: this.readonly,
          disabled: this.disabled
        }

        const newBlock = Object.assign({}, essentials, this.fields)
        this.localValue.push(Vue.observable(_.cloneDeep(newBlock)))
        this.localValue = this.localValue.slice()
        // Vue.set(this.localValue, this.localValue.length, _.clone(newBlock));
        this.numberOfNewBlocks++
      },
      getErrorMessagesForBlock (key) {
        let newErrors = {}
        for (let [fieldName, value] of Object.entries(this.getRelevantErrorMessages)) {
          newErrors[fieldName.replace(`[${key}].`, '')] = value
        }

        return newErrors
      }
    },
    computed: {
      getRelevantErrorMessages () {
        const realHandle = this.handle.replace('field_', '')
        const fieldNames = _.keys(this.errorMessages).filter((fieldName) => fieldName.startsWith(realHandle))

        let newErrors = {}
        for (let i = 0; i < fieldNames.length; i++) {
          newErrors[fieldNames[i].replace(realHandle, '')] = this.errorMessages[fieldNames[i]]
        }

        return newErrors
      },
      isDisabled () {
        return this.readonly === true || this.disabled === true || this.loading === true
      },
      localValue: {
        get () {
          let value = []
          // set loading, disabled and readonly statuses for each block
          if (Array.isArray(this.value)) {
            this.value.forEach(el => {
              const v = _.clone(el)
              if (this.readonly === true) {
                v.readonly = true
              }
              if (this.disabled === true) {
                v.disabled = true
              }

              if (this.loading === true) {
                v.loading = true
              }

              value.push(v)
            })
          }

          return value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    },
    components: { 'dynamic-layer': DynamicLayer },
    name: 'Matrix'
  }
</script>

<style scoped>
    /* Enter and leave animations can use different */
    /* durations and timing functions.              */
    .slide-fade-enter-active {
        transition: all .3s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
</style>
